import { useMemo } from 'react';

import { getBrandingConfig, type BrandConfig } from '@/config/branding';

/** TagadaPay platform brand — never org/reseller partner overlay. */
export const usePlatformBranding = (): BrandConfig =>
  useMemo(() => getBrandingConfig(), []);
